import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-keep-control',
    templateUrl: './keep-control.component.html',
    styleUrls: ['./keep-control.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class KeepControlComponent {

}
